<template>
  <div>
    <header-help :is-loading="isLoading"></header-help>
    <section class="cp-page">
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container mt-3 position-relative" style="z-index: 1;">
        <div class="row">
          <div class="col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2">
            <div class="cp-content-card p-4 mt-5">
              <div class="pb-4">
                <h3 class="text-center font-weight-bold py-3 text-white">Add a tip to support {{ invitee.name }}</h3>
                <global-message></global-message>
              </div>
              <div class="custom-body">
                <div class="row justify-content-center">
                  <div class="col-12 text-center">
                    <div class="d-flex flex-wrap justify-content-center" style="gap: 8px;">
                      <span :class="{ active: isActive(25) }"
                        @click="selectedTip(25)">
                        <label class="mb-0 text-white cursor-pointer">$25</label>
                      </span>
                      <span :class="{ active: isActive(20) }"
                        @click="selectedTip(20)">
                        <label class="mb-0 text-white cursor-pointer">$20</label>
                      </span>
                      <span :class="{ active: isActive(15) }"
                        @click="selectedTip(15)">
                        <label class="mb-0 text-white cursor-pointer">$15</label>
                      </span>
                      <span :class="{ active: isActive(10) }"
                        @click="selectedTip(10)">
                        <label class="mb-0 text-white cursor-pointer">$10</label>
                      </span>
                    </div>
                  </div>

                  <div class="col-md-7 col-7 mt-4">
                    <div class="form-group text-center">
                      <label class="font-size-12 font-weight-bold text-white">Custom Amount</label>
                      <span class="danger ml-2" v-if="isRequired('amount')">This is required field</span>
                      <div class="input-group mt-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text cp-input border-end-0" style="border-radius: 12px 0 0 12px;">$</div>
                        </div>
                        <input type="number" min="0"
                          class="form-control cp-input border-start-0"
                          style="border-radius: 0 12px 12px 0;"
                          onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                          v-model="tip.amount">
                      </div>
                    </div>
                  </div>

                  <div class="col-md-7 col-11 mt-4 px-3">
                    <textarea
                      class="form-control cp-input"
                      rows="4"
                      placeholder="Donation Message"
                      v-model="tip.message"
                      style="border-radius: 12px;"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3 mb-5 mt-4">
            <button type="button"
              class="cp-btn-primary w-100 py-3"
              @click="donate()">Donate
            </button>
            <div class="text-center mt-3" v-if="!$route.query.donate">
              <button type="button"
                class="btn btn-ghost rounded-pill px-4 py-2 font-size-14 text-white"
                @click="skip()">Skip
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <stripe-checkout
      v-if="isShow"
      ref="checkoutRef"
      :pk="pk"
      :sessionId="sessionId"
    ></stripe-checkout>
  </div>
</template>

<script>

import {StripeCheckout} from '@vue-stripe/vue-stripe';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import {required} from "vuelidate/lib/validators";
import {mapActions} from "vuex";
import {SERVICE_SUBSCRIPTION} from "@/properties/micro-service";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import titleMixin from "@/mixin/title-mixin";
import {httpMixin} from "@/mixin/http-mixin";

export default {
  name: 'CustomerTip',
  title: 'Customer tip',
  mixins: [httpMixin, titleMixin],
  components: {GlobalMessage, LoadingModal, HeaderHelp, StripeCheckout},
  data() {
    return {
      invitee: {},
      tip: {},
      isSubmit: false,
      pk: "",
      sessionId: "",
      isShow: false,
      paymentButtonClicked: false,
    }
  },
  validations: {
    tip: {
      amount: {required}
    }
  },
  created() {
    this.invitee = this.getInvitee;
  },
  methods: {
    ...mapActions(['setMessage']),
    isRequired(attrib) {
      return this.isSubmit && !this.$v.tip[attrib].required;
    },
    selectedTip(value) {
      this.$set(this.tip, 'amount', value);
      this.tip.amount = value;
    },
    skip() {
      let donate = this.$route.query.donate;
      if (this.getCreatePlatform || donate) {
        this.showCustomerContent();
      } else {
        this.$router.replace({name: 'CustomerBonusContentList'});
      }
    },
    donate() {
      this.isSubmit = true;
      this.$v.$touch();

      if(this.tip.amount<10){
        return;
      }

      if (this.$v.$invalid) {
        return;
      }

      this.tip.influencer = {id: this.invitee.id};
      this.tip.customer = {id: this.getUser.id};
      let url = `${SERVICE_SUBSCRIPTION}/api/v1/customers/${this.getUser.id}/tip`;
      this.postData(url, this.tip, (tip) => {
        this.tip = tip;
        localStorage.setItem('tip', tip.amount);
        let stripeCheckoutData = tip.transaction;
        let otherData = stripeCheckoutData.othersData;
        let status = stripeCheckoutData.status;
        this.pk = otherData.pk;
        this.sessionId = stripeCheckoutData.req.id;

        if (status === 'Success') {
          let donate = this.$route.query.donate;
          if (this.getCreatePlatform || donate) {
            this.$router.push({ name: 'TipComplete', query: { donate: true } });
           } else {
            this.$router.replace({name: 'TipComplete'});
          }
        } else if (status === 'InProgress') {
          this.pushGlobalError(otherData.offlineCheckoutError);
          setTimeout(() => {
            this.isShow = true;
            this.$nextTick(() => {
              this.$refs.checkoutRef.redirectToCheckout();
            });
          }, 2000);
        }

      });

    }
  }
}
;
</script>

<style scoped>
.select-tags {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  padding: 10px 25px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.select-tags:hover {
  background: rgba(255, 255, 255, 0.1);
}
.select-tags.active {
  background: linear-gradient(90deg, rgba(243, 218, 107, 0.3), rgba(229, 59, 185, 0.3));
  border-color: #E53BB9;
}
</style>